import { observable } from 'mobx';
import * as TextService from 'services/TextService';

/**
 * 基本信息Store
 */
class TextStore {
  @observable
  share = {
    title: '',
    content: '',
    img: '',
  };
  @observable
  homePage = {
    pcTopTitle: '',
    pcTitleUrl: '',
    pcBanner: [
      {
        pcBannerWrapUrl: '',
        pcBannerWrapData: '',
        pcBannerWrapDescription: '',
      },
      {
        pcBannerWrapUrl: '',
        pcBannerWrapData: '',
        pcBannerWrapDescription: '',
      },
      {
        pcBannerWrapUrl: '',
        pcBannerWrapData: '',
        pcBannerWrapDescription: '',
      },
    ],
    pcHomeTitle: {
      activityTheme: '',
      homeTitleLeft: '',
      homeTitleRight: '',
      homeTitleEnd: '',
    },
    pcHomeStrategy: {
      strategyTitle: '',
      strategyList: [
        {
          header: '',
          price: {
            number: '',
            desc: '',
          },
          theme: '',
          introduction: '',
        },
      ],
    },
    pcNewUser: {
      newUserTitle: '',
      newUserDesc: '',
    },
    pcMoreVenues: [
      {
        productBg: '',
        productURL: '',
        productName: '',
        productDescription: '',
        productImg: '',
      },
    ],
  };
  @observable
  selfPage = {
    pcSelf: {
      title: '',
      desc: '',
      description: {
        teamHeadcount: '',
        teamPrice: '',
        meHeadcount: '',
        mePrice: '',
        teamDiscount: '',
        teamPCDiscount: '',
        meRedPacket: '',
        myReturn: '',
        refundAmount: '',
        teamcurrentRank: '',
      },
    },
  };
  @observable
  mobileHomePage = {
    mobileTopTitle: '',
    mobileBanner: [
      {
        mobileBannerWrapTime: '',
        mobileBannerWrapTitle: '',
        mobileBannerWrapDescription: '',
      },
      {
        mobileBannerWrapTime: '',
        mobileBannerWrapTitle: '',
        mobileBannerWrapDescription: '',
      },
      {
        mobileBannerWrapTime: '',
        mobileBannerWrapTitle: '',
        mobileBannerWrapDescription: '',
      },
    ],
    mobileHomeTitle: {
      activityTheme: '',
      homeTitleTop: '',
      homeTitleBottom: '',
      homeTitleEnd: '',
    },
    mobileHomeStrategy: {
      strategyTitle: '',
      strategyList: [
        {
          number: '',
          content: {
            top: '',
            bottom: '',
          },
          theme: '',
        },
      ],
    },
    mobileMoreVenues: [
      {
        productBg: '',
        productURL: '',
        productName: '',
        productDescription: '',
        productImg: '',
      },
    ],
  };
  @observable
  sharePage = {
    pcShare: {
      firstTitle: '',
      secondTitle: '',
    },
  };
  @observable
  pkPage = {};
  @observable
  tips = [];
  constructor() {
    this.fetchPCHomeText();
    this.fetchPCSelfText();
    this.fetchShareText();
    this.fetchMobileHomeText();
    this.fetchPCShareText();
    this.fetchPkText();
    this.fetchTipsText();
  }
  async fetchTipsText() {
    const data = await TextService.fetchTipsText();
    this.tips = data;
  }
  async fetchPCShareText() {
    const data = await TextService.fetchPCShareText();
    this.sharePage = data;
  }
  async fetchShareText() {
    const data = await TextService.fetchShareText();
    this.share = data;
  }
  async fetchPCHomeText() {
    const data = await TextService.fetchPCHomeText();
    if (data) {
      this.homePage = data;
    }
  }
  async fetchMobileHomeText() {
    const data = await TextService.fetchMobileHomeText();
    this.mobileHomePage = data;
  }
  async fetchPCSelfText() {
    const data = await TextService.fetchPCSelfText();
    this.selfPage = data;
  }
  async fetchPkText() {
    const data = await TextService.fetchPkText();
    this.pkPage = data;
  }
}
let textStore = new TextStore();
export default textStore;



// WEBPACK FOOTER //
// ./src/scripts/stores/TextStore.js